const fetchNews = {
  totalPoints: 'Total Points',
  ranking: 'Ranking',
  playNow: 'Play Now',
  getListRankingFail: 'Get list ranking fail!',
  previewFetchNews: "Preview Fetch News"
}

export default fetchNews
